import React from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";

const Content = ({reportData, data, entity, title, printComponentRef, setLoading, showMoreInformation}) => {

    return (
        <>
            {
                reportData && data > 0 && (
                    <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setLoading}>
                        <div className={"w-full mt-[25px] print:mt-[0]"}>
                            <ReportContent data={reportData} showMoreInformation={showMoreInformation}/>
                        </div>
                    </PrintTemplate>
                )
            }
        </>
    );
};

export default Content;
